import React from "react";
import { Button } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import classes from "./SyncActivities.module.scss";

const MAX_LENGTH = 140;

const ExpandableValue = ({ value, expanded, onToggle }) => {
  const isLong = value.length > MAX_LENGTH;

  return (
    <div className={classes.ValueCell}>
      <div className={!expanded && isLong ? classes.ValueClamped : undefined}>
        {value}
      </div>
      {isLong && (
        <Button size="small" className={classes.ExpandButton} onClick={onToggle}>
          {expanded ? <UpOutlined /> : <DownOutlined />}
        </Button>
      )}
    </div>
  );
};

export default ExpandableValue;
